import React from 'react'
import {connect} from 'react-redux'
import {TIMELINE_CHOICES, RECIPIENT_CHOICES, INTENT_CHOICES} from './data'
import {CalendarSelect, NotSure, PreviousLink, setCookie, nextFrame, backToHomepage} from './shared'
import {CheckMarkCard, HelpModal, Select} from 'js/studios/shared/flows'
import {classNames, keyActivationHandler} from 'js/studios/shared/utils'

@connect(state => ({
  recipient: state.projectCreationData.recipient,
  intent: state.projectCreationData.intent,
  significantOtherName: state.projectCreationData.significantOtherName,
  significantOtherNameSkip: state.projectCreationData.significantOtherNameSkip,
  budgetMin: state.projectCreationData.budgetMin,
  budgetMax: state.projectCreationData.budgetMax,
  budgetSkip: state.projectCreationData.budgetSkip
}))
export class RingRecipientFrame extends React.Component {
  MAX_NAME_LENGTH = 250
  state = { helpOpen: false, nameError: null }

  componentDidUpdate(prevProps, _prevState, _snapshot) {
    if (!this.props.significantOtherName && this.state.nameError) {
      this.setState({nameError: null})
    } else if (this.props.significantOtherName && this.props.significantOtherName !== prevProps.significantOtherName) {
      const name = this.props.significantOtherName
      if (name.length > this.MAX_NAME_LENGTH) {
        this.setState({nameError: 'Name must be shorter, sorry.'})
      } else if (/https?:/.test(name) || /www\./.test(name) || /\.(com|net|org)/.test(name)) {
        this.setState({nameError: "That looks like a URL, please enter your significant other's name."})
      } else {
        this.setState({nameError: null})
      }
    }
  }

  updateHelpModal(open) {
    this.setState({helpOpen: open})
  }

  get canContinue() {
    return this.props.recipient.length > 0 && (this.props.significantOtherNameSkip || this.props.intent || (this.props.significantOtherName && !this.state.nameError))
  }

  updateField(field, ev) {
    this.props.dispatch({
      type: "UPDATE_PROJECT_CREATION_FIELD",
      field: field,
      value: ev.target.value,
    })
  }

  onSubmit = (ev) => {
    ev.preventDefault()
    if (this.canContinue) { nextFrame() }
  }

  render() {
    return (
      <form className="frame-wrapper ring-recipient fade-in" onSubmit={this.onSubmit}>
        <div className="frame-contents-wrapper">
          <div className="frame">
            <h2><PreviousLink />Who Will Be Wearing the Ring?</h2>
            <p className="subheader-body added-margin">Are you designing a ring for your significant other, or designing your own ring?</p>
            <div className="field">
              <Select onChange={this.updateField.bind(this, 'recipient')} value={this.props.recipient} label="Choose recipient">
                {RECIPIENT_CHOICES.map(choice => <option key={choice.value} value={choice.value}>{choice.text}</option>)}
              </Select>
            </div>
            {this.props.recipient === 'S/O' && (
              <div className="fade-in">
                <p>Who’s the lucky guy or gal?</p>
                <div className="field">
                  <label htmlFor="signficant-other-first-name-input" hidden>Your Significant Other's First Name</label>
                  <input
                    type="text"
                    id="signficant-other-first-name-input"
                    disabled={this.props.significantOtherNameSkip}
                    className={classNames("significant-other-name-input", {disabled: this.props.significantOtherNameSkip})}
                    placeholder="Your S/O’s First Name"
                    value={this.props.significantOtherName}
                    onChange={this.updateField.bind(this, "significantOtherName")}
                    />
                  <a className="help material-icons-outlined"
                     tabIndex="0"
                     onClick={this.updateHelpModal.bind(this, true)}
                     onKeyDown={keyActivationHandler(this.updateHelpModal.bind(this, true))}>
                    info
                  </a>
                </div>
                {this.state.nameError && <div className="form-general-error">{this.state.nameError}</div>}
                <NotSure field="significantOtherNameSkip" fieldsToWipe={["significantOtherName"]} checked={this.props.significantOtherNameSkip}>I'd prefer not to say</NotSure>
              </div>
            )}
            {this.props.recipient === 'me' && (
              <div className="fade-in">
                <p>Looking around for a ring someone might surprise you with later, or are you planning to purchase your own ring?</p>
                <div className="field">
                  <Select onChange={this.updateField.bind(this, 'intent')} value={this.props.intent} label="Select response">
                    {INTENT_CHOICES.map(choice => <option key={choice.value} value={choice.value}>{choice.text}</option>)}
                  </Select>
                </div>
              </div>
            )}
            </div>
        </div>
        {this.canContinue && <div className="action-bar fade-in">
          <button className="btn btn-primary btn-sm">Next</button>
        </div>}
        <HelpModal name="significant-other-name" isOpen={this.state.helpOpen} onClose={this.updateHelpModal.bind(this, false)}>
          <p>
            Knowing your S/O's name just helps us keep our communication clear. Don't worry though, we won't tell them there's a ring in the works!
          </p>
        </HelpModal>
      </form>
    )
  }
}


const CENTER_STONE_CARDS = [
  {
    name: "diamond",
    img: "//images.custommade.com/fdzVYlZ6BhGdu4P6YkdA45k8ZdU=/custommade-attachments/a6ad58fe55709dc_diamond.jpg",
    label: "Diamond"
  },
  {
    name: "gem",
    img: "//images.custommade.com/2EZeH_PAdMdS0yeczjRgbNiYzIQ=/custommade-attachments/1c17957e696c838_colored_gem.jpg",
    label: "Colored Gemstone"
  },
  {
    name: "moissanite",
    img: "//images.custommade.com/ExXpHQlG4fDlquzS09GDSbL_cNc=/custommade-attachments/d55e4c8f0ee4236_moissanite.jpg",
    label: "Moissanite"
  },
  {
    name: "no_stone",
    img: "//images.custommade.com/7Q6zDX4NdUZEuCqIf0EPTUWt67g=/custommade-attachments/4e98357b15fa0dd_no_stone.jpg",
    label: "No Stone"
  }
]

@connect(state => ({
  centerStoneTypes: state.projectCreationData.centerStoneTypes,
  centerStoneSkip: state.projectCreationData.centerStoneSkip
}))
export class CenterStoneFrame extends React.Component {

  isChecked(name){
    return this.props.centerStoneTypes.indexOf(name) > -1
  }

  toggleChecked(name, _e){
    if (!this.props.centerStoneSkip){
      if (name === 'cpg'){
        this.props.dispatch({
          type: "UPDATE_PROJECT_CREATION_FIELD",
          field: "centerStoneTypes",
          value: []
        })
      } else {
        this.props.dispatch({
          type: "PROJECT_CREATION_REMOVE_CENTER_STONE_TYPE",
          value: "cpg"
        })
      }
      this.props.dispatch({
        type: this.isChecked(name) ? "PROJECT_CREATION_REMOVE_CENTER_STONE_TYPE" : "PROJECT_CREATION_ADD_CENTER_STONE_TYPE",
        value: name
      })


    }
  }

  render(){
    return (
      <form className="frame-wrapper center-stone fade-in" onSubmit={nextFrame}>
        <div className="frame-contents-wrapper">
          <div className="frame limit-2-items-per-row">
            <h2><PreviousLink />Your Center Stone</h2>
            <p className="subheader-body">What types of center stones might you be considering for your ring?</p>
            <div className="select-all-that-apply added-margin">SELECT ALL THAT APPLY</div>
            <div className="cards-wrapper">
              {CENTER_STONE_CARDS.map(card => {
                return <CheckMarkCard
                  key={card.name}
                  name={card.name}
                  className="card-normal"
                  imgUrl={card.img}
                  label={card.label}
                  checked={this.isChecked(card.name)}
                  disabled={this.props.centerStoneSkip}
                  toggleChecked={this.toggleChecked.bind(this, card.name)}
                  />
              })}
              <CheckMarkCard
                  key="cpg"
                  className="card-block card-text-blocks thin"
                  name="cpg"
                  label=""
                  description="I have my own diamond or gemstone I’d like to use"
                  checked={this.isChecked("cpg")}
                  disabled={this.props.centerStoneSkip}
                  toggleChecked={this.toggleChecked.bind(this, "cpg")}
                  >
              </CheckMarkCard>
            </div>
            <NotSure field="centerStoneSkip" fieldsToWipe={['centerStoneTypes']} resetValue={[]} checked={this.props.centerStoneSkip}>I'm not sure</NotSure>
          </div>
        </div>
        {(this.props.centerStoneTypes.length > 0 || this.props.centerStoneSkip) && (
          <div className="action-bar fade-in">
            <button className="btn btn-primary btn-sm">Next</button>
          </div>
        )}
      </form>
    )
  }
}

@connect(state => ({
  shopForSelf: state.projectCreationData.recipient === 'me',
  designVisionSources: state.projectCreationData.designVisionSources,
  designVisionSkip: state.projectCreationData.designVisionSkip,
}))
export class DesignVisionFrame extends React.Component {

  isChecked(name){
    return this.props.designVisionSources.indexOf(name) > -1
  }

  toggleChecked(name, _e){
    if (!this.props.designVisionSkip){
      this.props.dispatch({
        type: this.isChecked(name) ? "PROJECT_CREATION_REMOVE_DESIGN_VISION_TYPE" : "PROJECT_CREATION_ADD_DESIGN_VISION_TYPE",
        value: name
      })
    }
  }

  render(){

    let DESIGN_VISION_TYPES = [
      {
        name: 'has_images_to_share',
        description: 'I have images of inspiration ring(s) that I can share.'
      },
      {
        name: "has_details_to_share",
        description: "I have details or ideas I can share."
      }
    ]

    return (
      <form className="frame-wrapper design-vision fade-in" onSubmit={nextFrame}>
        <div className="frame-contents-wrapper">
          <div className="frame design-vision">
            <h2><PreviousLink />It Starts With Style</h2>
            <p className="subheader-body">Already know what ring style you’re going for, or are you not sure quite yet?</p>
            <div className="select-all-that-apply added-margin">SELECT ALL THAT APPLY</div>
            <div className="cards-wrapper">
              {DESIGN_VISION_TYPES.map(card => (
                <CheckMarkCard
                  key={card.name}
                  className="card-block card-text-blocks"
                  name={card.name}
                  label={card.label}
                  description={card.description}
                  checked={this.isChecked(card.name)}
                  disabled={this.props.nextStepsSkip}
                  toggleChecked={this.toggleChecked.bind(this, card.name)}
                  >
                </CheckMarkCard>
              ))}
            </div>
            <NotSure field="designVisionSkip" fieldsToWipe={['designVisionSources']} resetValue={[]} checked={this.props.designVisionSkip}>I have no ideas yet - I just want an amazing ring!</NotSure>
          </div>
        </div>
        {(this.props.designVisionSources.length > 0 || this.props.designVisionSkip) && (
          <div className="action-bar fade-in">
            <button className="btn btn-primary btn-sm">Next</button>
          </div>
        )}
      </form>
    )
  }
}


@connect(state => ({
  timeline: state.projectCreationData.timeline,
  deliveryDate: state.projectCreationData.deliveryDate
}))
export class DeliveryDateFrame extends React.Component {
  updateField(field, e){
    this.props.dispatch({
      type: "UPDATE_PROJECT_CREATION_FIELD",
      field: field,
      value: e.target.value,
    })
  }

  updateDeliveryDate = dateStr => this.props.dispatch({
      type: "UPDATE_PROJECT_CREATION_FIELD",
      field: "deliveryDate",
      value: dateStr,
  })

  render(){
    return (
      <form className="frame-wrapper delivery-date fade-in" onSubmit={nextFrame}>
        <div className="frame-contents-wrapper">
          <div className="frame">
            <h2><PreviousLink />When's the Special Day</h2>
            <div className="subheader-body added-margin">
              <p>If you have a planned proposal in mind, let us know so we can make sure your project stays on track.</p>
              <p>If you don't have a date yet, or you're just starting to look around, that's okay too!</p>
              <p>Note that the minimum time required for production is 4 weeks.</p>
            </div>
            <div className="field">
              <Select onChange={this.updateField.bind(this, 'timeline')} value={this.props.timeline} label="Choose a response">
                {TIMELINE_CHOICES.map(choice => <option key={choice.value} value={choice.value}>{choice.text}</option>)}
              </Select>
            </div>
            {this.props.timeline === 'specific_date' &&
              <CalendarSelect value={this.props.deliveryDate} onChange={this.updateDeliveryDate} />
            }
          </div>
        </div>
        {((this.props.timeline && this.props.timeline !== 'specific_date') || (this.props.timeline === 'specific_date' && this.props.deliveryDate)) && (
          <div className="action-bar fade-in">
            <button className="btn btn-primary btn-sm">Next</button>
          </div>
        )}
      </form>
    )
  }
}


export class ReferringLeadPreventionFrame extends React.Component {

  componentDidMount(){
    setCookie('prevention_frame', 'prevention-referring-lead')
  }

  render(){
    return (
      <form className="frame-wrapper prevention-frame fade-in" onSubmit={backToHomepage}>
        <div className="frame-contents-wrapper">
          <div className="frame">
            <div className="img-wrapper">
              <img src="//images.custommade.com/Fyqsyd-lFeUPiJqiYDs6B1i4m6s=/custommade-attachments/ab1a91d44dedcbe_custom_made_icon_diamond.png" />
            </div>
            <h2>Stay Tuned!</h2>
            <div className="subheader-body">
              <p>We know that some customers are interested in designing their own ring and need a special experience all of their own... so that's what we're setting out to create!</p>
              <p>Check back in soon for designing your own engagement ring.</p>
            </div>
          </div>
        </div>
        <div className="action-bar fade-in">
          <button className="btn btn-primary btn-sm">Back to homepage</button>
        </div>
      </form>
    )
  }
}
